import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ButtonComponent, InfoComponent, LoaderComponent } from '@swissfex/sfx-commons';

import { MAIN_ROUTES } from '../constants';
import { RouterService } from '../core/services/router.service';
import { AuthenticationService } from '../projects/services/authentication.service';

@Component({
    templateUrl: './key4-training-completed.component.html',
    styleUrls: ['./key4-training-completed.component.scss'],
    imports: [ButtonComponent, InfoComponent, LoaderComponent]
})
export class Key4TrainingCompletedComponent implements OnInit, OnDestroy {
    private readonly authSvc = inject(AuthenticationService);
    private readonly routerSvc = inject(RouterService);

    public didCallFail = signal(false);
    public hasWaitedAnExtendedPeriod = signal(false);
    public isCallInProgress = signal(false);

    private timeout: ReturnType<typeof setTimeout>;

    public async ngOnInit(): Promise<void> {
        this.timeout = setTimeout(() => {
            this.hasWaitedAnExtendedPeriod.set(true);
        }, 10000);

        const user = await this.authSvc.getCurrentUser();
        if (user) {
            await this.retryCall();
        }
    }

    public ngOnDestroy(): void {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
    }

    public async retryCall(): Promise<void> {
        this.didCallFail.set(false);
        this.isCallInProgress.set(true);
        try {
            await this.authSvc.markKey4TrainingAsCompleted();
            await this.redirectToProjects();
        } catch {
            this.didCallFail.set(true);
        } finally {
            this.isCallInProgress.set(false);
        }
    }

    public async redirectToProjects(): Promise<void> {
        await this.routerSvc.navigateToRoute([MAIN_ROUTES.PROJECTS]);
    }
}
